"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IconNames;
(function (IconNames) {
    IconNames["DecreaseIndentLegacy"] = "DecreaseIndentLegacy";
    IconNames["IncreaseIndentLegacy"] = "IncreaseIndentLegacy";
    IconNames["GlobalNavButton"] = "GlobalNavButton";
    IconNames["InternetSharing"] = "InternetSharing";
    IconNames["Brightness"] = "Brightness";
    IconNames["MapPin"] = "MapPin";
    IconNames["Airplane"] = "Airplane";
    IconNames["Tablet"] = "Tablet";
    IconNames["QuickNote"] = "QuickNote";
    IconNames["ChevronDown"] = "ChevronDown";
    IconNames["ChevronUp"] = "ChevronUp";
    IconNames["Edit"] = "Edit";
    IconNames["Add"] = "Add";
    IconNames["Cancel"] = "Cancel";
    IconNames["More"] = "More";
    IconNames["Settings"] = "Settings";
    IconNames["Video"] = "Video";
    IconNames["Mail"] = "Mail";
    IconNames["People"] = "People";
    IconNames["Phone"] = "Phone";
    IconNames["Pin"] = "Pin";
    IconNames["Shop"] = "Shop";
    IconNames["Stop"] = "Stop";
    IconNames["Link"] = "Link";
    IconNames["Filter"] = "Filter";
    IconNames["Zoom"] = "Zoom";
    IconNames["ZoomOut"] = "ZoomOut";
    IconNames["Microphone"] = "Microphone";
    IconNames["Search"] = "Search";
    IconNames["Camera"] = "Camera";
    IconNames["Attach"] = "Attach";
    IconNames["Send"] = "Send";
    IconNames["FavoriteList"] = "FavoriteList";
    IconNames["PageSolid"] = "PageSolid";
    IconNames["Forward"] = "Forward";
    IconNames["Back"] = "Back";
    IconNames["Refresh"] = "Refresh";
    IconNames["Share"] = "Share";
    IconNames["Lock"] = "Lock";
    IconNames["EMI"] = "EMI";
    IconNames["MiniLink"] = "MiniLink";
    IconNames["Blocked"] = "Blocked";
    IconNames["FavoriteStar"] = "FavoriteStar";
    IconNames["FavoriteStarFill"] = "FavoriteStarFill";
    IconNames["ReadingMode"] = "ReadingMode";
    IconNames["Favicon"] = "Favicon";
    IconNames["Remove"] = "Remove";
    IconNames["Checkbox"] = "Checkbox";
    IconNames["CheckboxComposite"] = "CheckboxComposite";
    IconNames["CheckboxIndeterminate"] = "CheckboxIndeterminate";
    IconNames["CheckboxCompositeReversed"] = "CheckboxCompositeReversed";
    IconNames["CheckMark"] = "CheckMark";
    IconNames["BackToWindow"] = "BackToWindow";
    IconNames["FullScreen"] = "FullScreen";
    IconNames["Print"] = "Print";
    IconNames["Up"] = "Up";
    IconNames["Down"] = "Down";
    IconNames["Delete"] = "Delete";
    IconNames["Save"] = "Save";
    IconNames["Cloud"] = "Cloud";
    IconNames["CommandPrompt"] = "CommandPrompt";
    IconNames["Sad"] = "Sad";
    IconNames["SIPMove"] = "SIPMove";
    IconNames["EraseTool"] = "EraseTool";
    IconNames["GripperTool"] = "GripperTool";
    IconNames["Dialpad"] = "Dialpad";
    IconNames["PageLeft"] = "PageLeft";
    IconNames["PageRight"] = "PageRight";
    IconNames["MultiSelect"] = "MultiSelect";
    IconNames["Play"] = "Play";
    IconNames["Pause"] = "Pause";
    IconNames["ChevronLeft"] = "ChevronLeft";
    IconNames["ChevronRight"] = "ChevronRight";
    IconNames["Emoji2"] = "Emoji2";
    IconNames["GripperBarHorizontal"] = "GripperBarHorizontal";
    IconNames["System"] = "System";
    IconNames["Personalize"] = "Personalize";
    IconNames["SearchAndApps"] = "SearchAndApps";
    IconNames["Globe"] = "Globe";
    IconNames["ContactInfo"] = "ContactInfo";
    IconNames["Unpin"] = "Unpin";
    IconNames["Contact"] = "Contact";
    IconNames["Memo"] = "Memo";
    IconNames["Paste"] = "Paste";
    IconNames["WindowsLogo"] = "WindowsLogo";
    IconNames["Error"] = "Error";
    IconNames["GripperBarVertical"] = "GripperBarVertical";
    IconNames["Unlock"] = "Unlock";
    IconNames["Calendar"] = "Calendar";
    IconNames["Megaphone"] = "Megaphone";
    IconNames["AutoEnhanceOn"] = "AutoEnhanceOn";
    IconNames["AutoEnhanceOff"] = "AutoEnhanceOff";
    IconNames["Color"] = "Color";
    IconNames["SaveAs"] = "SaveAs";
    IconNames["Light"] = "Light";
    IconNames["Filters"] = "Filters";
    IconNames["AspectRatio"] = "AspectRatio";
    IconNames["Contrast"] = "Contrast";
    IconNames["Redo"] = "Redo";
    IconNames["Undo"] = "Undo";
    IconNames["PhotoCollection"] = "PhotoCollection";
    IconNames["Album"] = "Album";
    IconNames["Rotate"] = "Rotate";
    IconNames["PanoIndicator"] = "PanoIndicator";
    IconNames["RedEye"] = "RedEye";
    IconNames["ThumbnailView"] = "ThumbnailView";
    IconNames["Package"] = "Package";
    IconNames["Warning"] = "Warning";
    IconNames["Financial"] = "Financial";
    IconNames["Education"] = "Education";
    IconNames["ShoppingCart"] = "ShoppingCart";
    IconNames["Train"] = "Train";
    IconNames["Flag"] = "Flag";
    IconNames["Move"] = "Move";
    IconNames["Page"] = "Page";
    IconNames["TouchPointer"] = "TouchPointer";
    IconNames["Merge"] = "Merge";
    IconNames["TurnRight"] = "TurnRight";
    IconNames["Ferry"] = "Ferry";
    IconNames["Highlight"] = "Highlight";
    IconNames["Tab"] = "Tab";
    IconNames["Admin"] = "Admin";
    IconNames["TVMonitor"] = "TVMonitor";
    IconNames["Speakers"] = "Speakers";
    IconNames["Nav2DMapView"] = "Nav2DMapView";
    IconNames["Car"] = "Car";
    IconNames["Bus"] = "Bus";
    IconNames["EatDrink"] = "EatDrink";
    IconNames["LocationCircle"] = "LocationCircle";
    IconNames["Home"] = "Home";
    IconNames["SwitcherStartEnd"] = "SwitcherStartEnd";
    IconNames["ParkingLocation"] = "ParkingLocation";
    IconNames["IncidentTriangle"] = "IncidentTriangle";
    IconNames["Touch"] = "Touch";
    IconNames["MapDirections"] = "MapDirections";
    IconNames["History"] = "History";
    IconNames["Location"] = "Location";
    IconNames["Work"] = "Work";
    IconNames["Recent"] = "Recent";
    IconNames["Hotel"] = "Hotel";
    IconNames["LocationDot"] = "LocationDot";
    IconNames["News"] = "News";
    IconNames["Chat"] = "Chat";
    IconNames["Group"] = "Group";
    IconNames["View"] = "View";
    IconNames["Previous"] = "Previous";
    IconNames["Next"] = "Next";
    IconNames["Clear"] = "Clear";
    IconNames["Sync"] = "Sync";
    IconNames["Download"] = "Download";
    IconNames["Help"] = "Help";
    IconNames["Upload"] = "Upload";
    IconNames["Emoji"] = "Emoji";
    IconNames["MailForward"] = "MailForward";
    IconNames["ClosePane"] = "ClosePane";
    IconNames["OpenPane"] = "OpenPane";
    IconNames["PreviewLink"] = "PreviewLink";
    IconNames["ZoomIn"] = "ZoomIn";
    IconNames["Bookmarks"] = "Bookmarks";
    IconNames["Document"] = "Document";
    IconNames["ProtectedDocument"] = "ProtectedDocument";
    IconNames["OpenInNewWindow"] = "OpenInNewWindow";
    IconNames["MailFill"] = "MailFill";
    IconNames["ViewAll"] = "ViewAll";
    IconNames["Switch"] = "Switch";
    IconNames["Rename"] = "Rename";
    IconNames["Import"] = "Import";
    IconNames["Folder"] = "Folder";
    IconNames["Picture"] = "Picture";
    IconNames["ShowResults"] = "ShowResults";
    IconNames["Message"] = "Message";
    IconNames["CalendarDay"] = "CalendarDay";
    IconNames["CalendarWeek"] = "CalendarWeek";
    IconNames["MailReplyAll"] = "MailReplyAll";
    IconNames["Read"] = "Read";
    IconNames["Cut"] = "Cut";
    IconNames["PaymentCard"] = "PaymentCard";
    IconNames["Copy"] = "Copy";
    IconNames["Important"] = "Important";
    IconNames["MailReply"] = "MailReply";
    IconNames["Sort"] = "Sort";
    IconNames["GotoToday"] = "GotoToday";
    IconNames["Font"] = "Font";
    IconNames["FontColor"] = "FontColor";
    IconNames["FolderFill"] = "FolderFill";
    IconNames["Permissions"] = "Permissions";
    IconNames["DisableUpdates"] = "DisableUpdates";
    IconNames["Unfavorite"] = "Unfavorite";
    IconNames["Italic"] = "Italic";
    IconNames["Underline"] = "Underline";
    IconNames["Bold"] = "Bold";
    IconNames["MoveToFolder"] = "MoveToFolder";
    IconNames["Dislike"] = "Dislike";
    IconNames["Like"] = "Like";
    IconNames["AlignRight"] = "AlignRight";
    IconNames["AlignCenter"] = "AlignCenter";
    IconNames["AlignLeft"] = "AlignLeft";
    IconNames["OpenFile"] = "OpenFile";
    IconNames["FontDecrease"] = "FontDecrease";
    IconNames["FontIncrease"] = "FontIncrease";
    IconNames["FontSize"] = "FontSize";
    IconNames["CellPhone"] = "CellPhone";
    IconNames["Tag"] = "Tag";
    IconNames["Library"] = "Library";
    IconNames["PostUpdate"] = "PostUpdate";
    IconNames["NewFolder"] = "NewFolder";
    IconNames["CalendarReply"] = "CalendarReply";
    IconNames["UnsyncFolder"] = "UnsyncFolder";
    IconNames["SyncFolder"] = "SyncFolder";
    IconNames["BlockContact"] = "BlockContact";
    IconNames["AddFriend"] = "AddFriend";
    IconNames["BulletedList"] = "BulletedList";
    IconNames["Preview"] = "Preview";
    IconNames["World"] = "World";
    IconNames["Comment"] = "Comment";
    IconNames["DockLeft"] = "DockLeft";
    IconNames["DockRight"] = "DockRight";
    IconNames["Repair"] = "Repair";
    IconNames["Accounts"] = "Accounts";
    IconNames["RadioBullet"] = "RadioBullet";
    IconNames["Stopwatch"] = "Stopwatch";
    IconNames["Clock"] = "Clock";
    IconNames["WorldClock"] = "WorldClock";
    IconNames["AlarmClock"] = "AlarmClock";
    IconNames["Hospital"] = "Hospital";
    IconNames["Timer"] = "Timer";
    IconNames["FullCircleMask"] = "FullCircleMask";
    IconNames["LocationFill"] = "LocationFill";
    IconNames["ChromeMinimize"] = "ChromeMinimize";
    IconNames["Annotation"] = "Annotation";
    IconNames["ChromeClose"] = "ChromeClose";
    IconNames["Accept"] = "Accept";
    IconNames["Fingerprint"] = "Fingerprint";
    IconNames["Handwriting"] = "Handwriting";
    IconNames["StackIndicator"] = "StackIndicator";
    IconNames["Completed"] = "Completed";
    IconNames["Label"] = "Label";
    IconNames["FlickDown"] = "FlickDown";
    IconNames["FlickUp"] = "FlickUp";
    IconNames["FlickLeft"] = "FlickLeft";
    IconNames["FlickRight"] = "FlickRight";
    IconNames["Streaming"] = "Streaming";
    IconNames["MusicInCollection"] = "MusicInCollection";
    IconNames["OneDrive"] = "OneDrive";
    IconNames["CompassNW"] = "CompassNW";
    IconNames["Code"] = "Code";
    IconNames["LightningBolt"] = "LightningBolt";
    IconNames["Info"] = "Info";
    IconNames["CalculatorMultiply"] = "CalculatorMultiply";
    IconNames["CalculatorAddition"] = "CalculatorAddition";
    IconNames["CalculatorSubtract"] = "CalculatorSubtract";
    IconNames["CalculatorEqualTo"] = "CalculatorEqualTo";
    IconNames["PrintfaxPrinterFile"] = "PrintfaxPrinterFile";
    IconNames["Communications"] = "Communications";
    IconNames["Headset"] = "Headset";
    IconNames["Health"] = "Health";
    IconNames["ChevronUpSmall"] = "ChevronUpSmall";
    IconNames["ChevronDownSmall"] = "ChevronDownSmall";
    IconNames["ChevronLeftSmall"] = "ChevronLeftSmall";
    IconNames["ChevronRightSmall"] = "ChevronRightSmall";
    IconNames["ChevronUpMed"] = "ChevronUpMed";
    IconNames["ChevronDownMed"] = "ChevronDownMed";
    IconNames["ChevronLeftMed"] = "ChevronLeftMed";
    IconNames["ChevronRightMed"] = "ChevronRightMed";
    IconNames["Dictionary"] = "Dictionary";
    IconNames["ChromeBack"] = "ChromeBack";
    IconNames["PC1"] = "PC1";
    IconNames["PresenceChickletVideo"] = "PresenceChickletVideo";
    IconNames["Reply"] = "Reply";
    IconNames["HalfAlpha"] = "HalfAlpha";
    IconNames["LockSolid"] = "LockSolid";
    IconNames["ConstructionCone"] = "ConstructionCone";
    IconNames["DoubleChevronLeftMed"] = "DoubleChevronLeftMed";
    IconNames["Volume0"] = "Volume0";
    IconNames["Volume1"] = "Volume1";
    IconNames["Volume2"] = "Volume2";
    IconNames["Volume3"] = "Volume3";
    IconNames["CaretHollow"] = "CaretHollow";
    IconNames["CaretSolid"] = "CaretSolid";
    IconNames["FolderOpen"] = "FolderOpen";
    IconNames["Pinned"] = "Pinned";
    IconNames["PinnedFill"] = "PinnedFill";
    IconNames["Chart"] = "Chart";
    IconNames["Robot"] = "Robot";
    IconNames["BidiLtr"] = "BidiLtr";
    IconNames["BidiRtl"] = "BidiRtl";
    IconNames["RevToggleKey"] = "RevToggleKey";
    IconNames["RightDoubleQuote"] = "RightDoubleQuote";
    IconNames["Sunny"] = "Sunny";
    IconNames["CloudWeather"] = "CloudWeather";
    IconNames["Cloudy"] = "Cloudy";
    IconNames["PartlyCloudyDay"] = "PartlyCloudyDay";
    IconNames["PartlyCloudyNight"] = "PartlyCloudyNight";
    IconNames["ClearNight"] = "ClearNight";
    IconNames["RainShowersDay"] = "RainShowersDay";
    IconNames["Rain"] = "Rain";
    IconNames["Thunderstorms"] = "Thunderstorms";
    IconNames["RainSnow"] = "RainSnow";
    IconNames["Snow"] = "Snow";
    IconNames["BlowingSnow"] = "BlowingSnow";
    IconNames["Frigid"] = "Frigid";
    IconNames["Fog"] = "Fog";
    IconNames["Squalls"] = "Squalls";
    IconNames["Duststorm"] = "Duststorm";
    IconNames["Unknown"] = "Unknown";
    IconNames["Precipitation"] = "Precipitation";
    IconNames["Ringer"] = "Ringer";
    IconNames["PDF"] = "PDF";
    IconNames["SortLines"] = "SortLines";
    IconNames["Ribbon"] = "Ribbon";
    IconNames["AreaChart"] = "AreaChart";
    IconNames["Assign"] = "Assign";
    IconNames["CheckList"] = "CheckList";
    IconNames["Diagnostic"] = "Diagnostic";
    IconNames["Generate"] = "Generate";
    IconNames["LineChart"] = "LineChart";
    IconNames["Equalizer"] = "Equalizer";
    IconNames["BarChartHorizontal"] = "BarChartHorizontal";
    IconNames["BarChartVertical"] = "BarChartVertical";
    IconNames["Freezing"] = "Freezing";
    IconNames["Processing"] = "Processing";
    IconNames["SnowShowerDay"] = "SnowShowerDay";
    IconNames["HailDay"] = "HailDay";
    IconNames["WorkFlow"] = "WorkFlow";
    IconNames["StoreLogoMed"] = "StoreLogoMed";
    IconNames["TriangleSolid"] = "TriangleSolid";
    IconNames["RainShowersNight"] = "RainShowersNight";
    IconNames["SnowShowerNight"] = "SnowShowerNight";
    IconNames["HailNight"] = "HailNight";
    IconNames["Info2"] = "Info2";
    IconNames["StoreLogo"] = "StoreLogo";
    IconNames["MultiSelectMirrored"] = "MultiSelectMirrored";
    IconNames["Broom"] = "Broom";
    IconNames["MusicInCollectionFill"] = "MusicInCollectionFill";
    IconNames["List"] = "List";
    IconNames["Asterisk"] = "Asterisk";
    IconNames["ErrorBadge"] = "ErrorBadge";
    IconNames["CircleRing"] = "CircleRing";
    IconNames["CircleFill"] = "CircleFill";
    IconNames["Record2"] = "Record2";
    IconNames["BookmarksMirrored"] = "BookmarksMirrored";
    IconNames["BulletedListMirrored"] = "BulletedListMirrored";
    IconNames["CaretHollowMirrored"] = "CaretHollowMirrored";
    IconNames["CaretSolidMirrored"] = "CaretSolidMirrored";
    IconNames["ChromeBackMirrored"] = "ChromeBackMirrored";
    IconNames["ClosePaneMirrored"] = "ClosePaneMirrored";
    IconNames["DockLeftMirrored"] = "DockLeftMirrored";
    IconNames["DoubleChevronLeftMedMirrored"] = "DoubleChevronLeftMedMirrored";
    IconNames["HelpMirrored"] = "HelpMirrored";
    IconNames["ImportMirrored"] = "ImportMirrored";
    IconNames["ListMirrored"] = "ListMirrored";
    IconNames["MailForwardMirrored"] = "MailForwardMirrored";
    IconNames["MailReplyMirrored"] = "MailReplyMirrored";
    IconNames["MailReplyAllMirrored"] = "MailReplyAllMirrored";
    IconNames["OpenPaneMirrored"] = "OpenPaneMirrored";
    IconNames["ParkingLocationMirrored"] = "ParkingLocationMirrored";
    IconNames["SendMirrored"] = "SendMirrored";
    IconNames["ShowResultsMirrored"] = "ShowResultsMirrored";
    IconNames["ThumbnailViewMirrored"] = "ThumbnailViewMirrored";
    IconNames["Devices3"] = "Devices3";
    IconNames["Lightbulb"] = "Lightbulb";
    IconNames["StatusTriangle"] = "StatusTriangle";
    IconNames["VolumeDisabled"] = "VolumeDisabled";
    IconNames["Puzzle"] = "Puzzle";
    IconNames["EmojiNeutral"] = "EmojiNeutral";
    IconNames["EmojiDisappointed"] = "EmojiDisappointed";
    IconNames["HomeSolid"] = "HomeSolid";
    IconNames["Cocktails"] = "Cocktails";
    IconNames["Wines"] = "Wines";
    IconNames["Articles"] = "Articles";
    IconNames["Cycling"] = "Cycling";
    IconNames["DietPlanNotebook"] = "DietPlanNotebook";
    IconNames["Pill"] = "Pill";
    IconNames["ExerciseTracker"] = "ExerciseTracker";
    IconNames["Medical"] = "Medical";
    IconNames["Running"] = "Running";
    IconNames["Weights"] = "Weights";
    IconNames["BarChart4"] = "BarChart4";
    IconNames["CirclePlus"] = "CirclePlus";
    IconNames["Coffee"] = "Coffee";
    IconNames["Cotton"] = "Cotton";
    IconNames["Market"] = "Market";
    IconNames["Money"] = "Money";
    IconNames["PieDouble"] = "PieDouble";
    IconNames["PieSingle"] = "PieSingle";
    IconNames["RemoveFilter"] = "RemoveFilter";
    IconNames["Savings"] = "Savings";
    IconNames["StockDown"] = "StockDown";
    IconNames["StockUp"] = "StockUp";
    IconNames["MSNVideos"] = "MSNVideos";
    IconNames["Cricket"] = "Cricket";
    IconNames["Golf"] = "Golf";
    IconNames["Baseball"] = "Baseball";
    IconNames["Soccer"] = "Soccer";
    IconNames["MoreSports"] = "MoreSports";
    IconNames["AutoRacing"] = "AutoRacing";
    IconNames["CollegeHoops"] = "CollegeHoops";
    IconNames["CollegeFootball"] = "CollegeFootball";
    IconNames["ProFootball"] = "ProFootball";
    IconNames["ProHockey"] = "ProHockey";
    IconNames["Rugby"] = "Rugby";
    IconNames["Tennis"] = "Tennis";
    IconNames["Arrivals"] = "Arrivals";
    IconNames["Design"] = "Design";
    IconNames["Website"] = "Website";
    IconNames["Drop"] = "Drop";
    IconNames["SkiResorts"] = "SkiResorts";
    IconNames["Snowflake"] = "Snowflake";
    IconNames["BusSolid"] = "BusSolid";
    IconNames["FerrySolid"] = "FerrySolid";
    IconNames["AirplaneSolid"] = "AirplaneSolid";
    IconNames["TrainSolid"] = "TrainSolid";
    IconNames["Heart"] = "Heart";
    IconNames["HeartFill"] = "HeartFill";
    IconNames["Ticket"] = "Ticket";
    IconNames["Devices4"] = "Devices4";
    IconNames["AzureLogo"] = "AzureLogo";
    IconNames["BingLogo"] = "BingLogo";
    IconNames["MSNLogo"] = "MSNLogo";
    IconNames["OutlookLogoInverse"] = "OutlookLogoInverse";
    IconNames["OfficeLogo"] = "OfficeLogo";
    IconNames["SkypeLogo"] = "SkypeLogo";
    IconNames["Door"] = "Door";
    IconNames["EditMirrored"] = "EditMirrored";
    IconNames["GiftCard"] = "GiftCard";
    IconNames["DoubleBookmark"] = "DoubleBookmark";
    IconNames["StatusErrorFull"] = "StatusErrorFull";
    IconNames["Certificate"] = "Certificate";
    IconNames["FastForward"] = "FastForward";
    IconNames["Rewind"] = "Rewind";
    IconNames["Photo2"] = "Photo2";
    IconNames["OpenSource"] = "OpenSource";
    IconNames["CloudDownload"] = "CloudDownload";
    IconNames["WindDirection"] = "WindDirection";
    IconNames["Family"] = "Family";
    IconNames["CSS"] = "CSS";
    IconNames["JS"] = "JS";
    IconNames["DeliveryTruck"] = "DeliveryTruck";
    IconNames["ReminderPerson"] = "ReminderPerson";
    IconNames["ReminderGroup"] = "ReminderGroup";
    IconNames["Umbrella"] = "Umbrella";
    IconNames["NetworkTower"] = "NetworkTower";
    IconNames["CityNext"] = "CityNext";
    IconNames["Section"] = "Section";
    IconNames["OneNoteLogoInverse"] = "OneNoteLogoInverse";
    IconNames["ToggleFilled"] = "ToggleFilled";
    IconNames["ToggleBorder"] = "ToggleBorder";
    IconNames["SliderThumb"] = "SliderThumb";
    IconNames["ToggleThumb"] = "ToggleThumb";
    IconNames["Documentation"] = "Documentation";
    IconNames["Badge"] = "Badge";
    IconNames["Giftbox"] = "Giftbox";
    IconNames["VisualStudioLogo"] = "VisualStudioLogo";
    IconNames["ExcelLogoInverse"] = "ExcelLogoInverse";
    IconNames["WordLogoInverse"] = "WordLogoInverse";
    IconNames["PowerPointLogoInverse"] = "PowerPointLogoInverse";
    IconNames["Cafe"] = "Cafe";
    IconNames["SpeedHigh"] = "SpeedHigh";
    IconNames["ThisPC"] = "ThisPC";
    IconNames["MusicNote"] = "MusicNote";
    IconNames["MicOff"] = "MicOff";
    IconNames["EdgeLogo"] = "EdgeLogo";
    IconNames["CompletedSolid"] = "CompletedSolid";
    IconNames["AlbumRemove"] = "AlbumRemove";
    IconNames["MessageFill"] = "MessageFill";
    IconNames["TabletSelected"] = "TabletSelected";
    IconNames["MobileSelected"] = "MobileSelected";
    IconNames["LaptopSelected"] = "LaptopSelected";
    IconNames["TVMonitorSelected"] = "TVMonitorSelected";
    IconNames["DeveloperTools"] = "DeveloperTools";
    IconNames["InsertTextBox"] = "InsertTextBox";
    IconNames["LowerBrightness"] = "LowerBrightness";
    IconNames["CloudUpload"] = "CloudUpload";
    IconNames["ScrollUpDown"] = "ScrollUpDown";
    IconNames["DateTime"] = "DateTime";
    IconNames["Event"] = "Event";
    IconNames["Cake"] = "Cake";
    IconNames["Tiles"] = "Tiles";
    IconNames["Org"] = "Org";
    IconNames["PartyLeader"] = "PartyLeader";
    IconNames["DRM"] = "DRM";
    IconNames["CloudAdd"] = "CloudAdd";
    IconNames["AppIconDefault"] = "AppIconDefault";
    IconNames["Photo2Add"] = "Photo2Add";
    IconNames["Photo2Remove"] = "Photo2Remove";
    IconNames["POI"] = "POI";
    IconNames["FacebookLogo"] = "FacebookLogo";
    IconNames["AddTo"] = "AddTo";
    IconNames["RadioBtnOff"] = "RadioBtnOff";
    IconNames["RadioBtnOn"] = "RadioBtnOn";
    IconNames["ExploreContent"] = "ExploreContent";
    IconNames["Embed"] = "Embed";
    IconNames["VideoSolid"] = "VideoSolid";
    IconNames["Teamwork"] = "Teamwork";
    IconNames["PeopleAdd"] = "PeopleAdd";
    IconNames["Glasses"] = "Glasses";
    IconNames["DateTime2"] = "DateTime2";
    IconNames["Shield"] = "Shield";
    IconNames["Header1"] = "Header1";
    IconNames["PageAdd"] = "PageAdd";
    IconNames["NumberedList"] = "NumberedList";
    IconNames["PowerBILogo"] = "PowerBILogo";
    IconNames["Product"] = "Product";
    IconNames["ProgressLoopInner"] = "ProgressLoopInner";
    IconNames["ProgressLoopOuter"] = "ProgressLoopOuter";
    IconNames["Blocked2"] = "Blocked2";
    IconNames["FangBody"] = "FangBody";
    IconNames["Glimmer"] = "Glimmer";
    IconNames["ChatInviteFriend"] = "ChatInviteFriend";
    IconNames["Crown"] = "Crown";
    IconNames["Feedback"] = "Feedback";
    IconNames["SharepointLogoInverse"] = "SharepointLogoInverse";
    IconNames["YammerLogo"] = "YammerLogo";
    IconNames["Hide"] = "Hide";
    IconNames["Uneditable"] = "Uneditable";
    IconNames["ReturnToSession"] = "ReturnToSession";
    IconNames["OpenFolderHorizontal"] = "OpenFolderHorizontal";
    IconNames["CalendarMirrored"] = "CalendarMirrored";
    IconNames["SwayLogoInverse"] = "SwayLogoInverse";
    IconNames["OutOfOffice"] = "OutOfOffice";
    IconNames["Trophy"] = "Trophy";
    IconNames["ReopenPages"] = "ReopenPages";
    IconNames["AADLogo"] = "AADLogo";
    IconNames["AccessLogo"] = "AccessLogo";
    IconNames["AdminALogoInverse32"] = "AdminALogoInverse32";
    IconNames["AdminCLogoInverse32"] = "AdminCLogoInverse32";
    IconNames["AdminDLogoInverse32"] = "AdminDLogoInverse32";
    IconNames["AdminELogoInverse32"] = "AdminELogoInverse32";
    IconNames["AdminLLogoInverse32"] = "AdminLLogoInverse32";
    IconNames["AdminMLogoInverse32"] = "AdminMLogoInverse32";
    IconNames["AdminOLogoInverse32"] = "AdminOLogoInverse32";
    IconNames["AdminPLogoInverse32"] = "AdminPLogoInverse32";
    IconNames["AdminSLogoInverse32"] = "AdminSLogoInverse32";
    IconNames["AdminYLogoInverse32"] = "AdminYLogoInverse32";
    IconNames["BoxLogo"] = "BoxLogo";
    IconNames["DelveLogoInverse"] = "DelveLogoInverse";
    IconNames["DropboxLogo"] = "DropboxLogo";
    IconNames["ExchangeLogoInverse"] = "ExchangeLogoInverse";
    IconNames["LyncLogo"] = "LyncLogo";
    IconNames["OfficeVideoLogoInverse"] = "OfficeVideoLogoInverse";
    IconNames["ParatureLogo"] = "ParatureLogo";
    IconNames["SocialListeningLogo"] = "SocialListeningLogo";
    IconNames["VisioLogoInverse"] = "VisioLogoInverse";
    IconNames["Balloons"] = "Balloons";
    IconNames["Cat"] = "Cat";
    IconNames["MailAlert"] = "MailAlert";
    IconNames["MailCheck"] = "MailCheck";
    IconNames["MailLowImportance"] = "MailLowImportance";
    IconNames["MailPause"] = "MailPause";
    IconNames["MailRepeat"] = "MailRepeat";
    IconNames["SecurityGroup"] = "SecurityGroup";
    IconNames["Table"] = "Table";
    IconNames["VoicemailForward"] = "VoicemailForward";
    IconNames["VoicemailReply"] = "VoicemailReply";
    IconNames["Waffle"] = "Waffle";
    IconNames["RemoveEvent"] = "RemoveEvent";
    IconNames["EventInfo"] = "EventInfo";
    IconNames["ForwardEvent"] = "ForwardEvent";
    IconNames["WipePhone"] = "WipePhone";
    IconNames["AddOnlineMeeting"] = "AddOnlineMeeting";
    IconNames["JoinOnlineMeeting"] = "JoinOnlineMeeting";
    IconNames["RemoveLink"] = "RemoveLink";
    IconNames["PeopleBlock"] = "PeopleBlock";
    IconNames["PeopleRepeat"] = "PeopleRepeat";
    IconNames["PeopleAlert"] = "PeopleAlert";
    IconNames["PeoplePause"] = "PeoplePause";
    IconNames["TransferCall"] = "TransferCall";
    IconNames["AddPhone"] = "AddPhone";
    IconNames["UnknownCall"] = "UnknownCall";
    IconNames["NoteReply"] = "NoteReply";
    IconNames["NoteForward"] = "NoteForward";
    IconNames["NotePinned"] = "NotePinned";
    IconNames["RemoveOccurrence"] = "RemoveOccurrence";
    IconNames["Timeline"] = "Timeline";
    IconNames["EditNote"] = "EditNote";
    IconNames["CircleHalfFull"] = "CircleHalfFull";
    IconNames["Room"] = "Room";
    IconNames["Unsubscribe"] = "Unsubscribe";
    IconNames["Subscribe"] = "Subscribe";
    IconNames["RecurringTask"] = "RecurringTask";
    IconNames["TaskManager"] = "TaskManager";
    IconNames["TaskManagerMirrored"] = "TaskManagerMirrored";
    IconNames["Combine"] = "Combine";
    IconNames["Split"] = "Split";
    IconNames["DoubleChevronUp"] = "DoubleChevronUp";
    IconNames["DoubleChevronLeft"] = "DoubleChevronLeft";
    IconNames["DoubleChevronRight"] = "DoubleChevronRight";
    IconNames["Ascending"] = "Ascending";
    IconNames["Descending"] = "Descending";
    IconNames["TextBox"] = "TextBox";
    IconNames["TextField"] = "TextField";
    IconNames["NumberField"] = "NumberField";
    IconNames["Dropdown"] = "Dropdown";
    IconNames["BookingsLogo"] = "BookingsLogo";
    IconNames["ClassNotebookLogoInverse"] = "ClassNotebookLogoInverse";
    IconNames["DelveAnalyticsLogo"] = "DelveAnalyticsLogo";
    IconNames["DocsLogoInverse"] = "DocsLogoInverse";
    IconNames["Dynamics365Logo"] = "Dynamics365Logo";
    IconNames["DynamicSMBLogo"] = "DynamicSMBLogo";
    IconNames["OfficeAssistantLogo"] = "OfficeAssistantLogo";
    IconNames["OfficeStoreLogo"] = "OfficeStoreLogo";
    IconNames["OneNoteEduLogoInverse"] = "OneNoteEduLogoInverse";
    IconNames["PlannerLogo"] = "PlannerLogo";
    IconNames["PowerApps"] = "PowerApps";
    IconNames["Suitcase"] = "Suitcase";
    IconNames["ProjectLogoInverse"] = "ProjectLogoInverse";
    IconNames["CaretLeft8"] = "CaretLeft8";
    IconNames["CaretRight8"] = "CaretRight8";
    IconNames["CaretUp8"] = "CaretUp8";
    IconNames["CaretDown8"] = "CaretDown8";
    IconNames["CaretLeftSolid8"] = "CaretLeftSolid8";
    IconNames["CaretRightSolid8"] = "CaretRightSolid8";
    IconNames["CaretUpSolid8"] = "CaretUpSolid8";
    IconNames["CaretDownSolid8"] = "CaretDownSolid8";
    IconNames["ClearFormatting"] = "ClearFormatting";
    IconNames["Superscript"] = "Superscript";
    IconNames["Subscript"] = "Subscript";
    IconNames["Strikethrough"] = "Strikethrough";
    IconNames["Export"] = "Export";
    IconNames["ExportMirrored"] = "ExportMirrored";
    IconNames["SingleBookmark"] = "SingleBookmark";
    IconNames["DoubleChevronDown"] = "DoubleChevronDown";
    IconNames["ReplyAll"] = "ReplyAll";
    IconNames["GoogleDriveLogo"] = "GoogleDriveLogo";
    IconNames["Questionnaire"] = "Questionnaire";
    IconNames["ReplyMirrored"] = "ReplyMirrored";
    IconNames["ReplyAllMirrored"] = "ReplyAllMirrored";
    IconNames["AddGroup"] = "AddGroup";
    IconNames["QuestionnaireMirrored"] = "QuestionnaireMirrored";
    IconNames["TemporaryUser"] = "TemporaryUser";
    IconNames["CaretSolid16"] = "CaretSolid16";
    IconNames["GroupedDescending"] = "GroupedDescending";
    IconNames["GroupedAscending"] = "GroupedAscending";
    IconNames["SortUp"] = "SortUp";
    IconNames["SortDown"] = "SortDown";
    IconNames["AwayStatus"] = "AwayStatus";
    IconNames["MyMoviesTV"] = "MyMoviesTV";
    IconNames["SyncToPC"] = "SyncToPC";
    IconNames["AustralianRules"] = "AustralianRules";
    IconNames["WifiEthernet"] = "WifiEthernet";
    IconNames["DateTimeMirrored"] = "DateTimeMirrored";
    IconNames["StopSolid"] = "StopSolid";
    IconNames["DoubleChevronUp12"] = "DoubleChevronUp12";
    IconNames["DoubleChevronDown12"] = "DoubleChevronDown12";
    IconNames["DoubleChevronLeft12"] = "DoubleChevronLeft12";
    IconNames["DoubleChevronRight12"] = "DoubleChevronRight12";
    IconNames["CalendarAgenda"] = "CalendarAgenda";
    IconNames["AddEvent"] = "AddEvent";
    IconNames["AssetLibrary"] = "AssetLibrary";
    IconNames["DataConnectionLibrary"] = "DataConnectionLibrary";
    IconNames["DocLibrary"] = "DocLibrary";
    IconNames["FormLibrary"] = "FormLibrary";
    IconNames["FormLibraryMirrored"] = "FormLibraryMirrored";
    IconNames["ReportLibrary"] = "ReportLibrary";
    IconNames["ReportLibraryMirrored"] = "ReportLibraryMirrored";
    IconNames["ContactCard"] = "ContactCard";
    IconNames["CustomList"] = "CustomList";
    IconNames["CustomListMirrored"] = "CustomListMirrored";
    IconNames["IssueTracking"] = "IssueTracking";
    IconNames["IssueTrackingMirrored"] = "IssueTrackingMirrored";
    IconNames["PictureLibrary"] = "PictureLibrary";
    IconNames["OfficeAddinsLogo"] = "OfficeAddinsLogo";
    IconNames["OfflineOneDriveParachute"] = "OfflineOneDriveParachute";
    IconNames["OfflineOneDriveParachuteDisabled"] = "OfflineOneDriveParachuteDisabled";
    IconNames["LargeGrid"] = "LargeGrid";
    IconNames["TriangleSolidUp12"] = "TriangleSolidUp12";
    IconNames["TriangleSolidDown12"] = "TriangleSolidDown12";
    IconNames["TriangleSolidLeft12"] = "TriangleSolidLeft12";
    IconNames["TriangleSolidRight12"] = "TriangleSolidRight12";
    IconNames["TriangleUp12"] = "TriangleUp12";
    IconNames["TriangleDown12"] = "TriangleDown12";
    IconNames["TriangleLeft12"] = "TriangleLeft12";
    IconNames["TriangleRight12"] = "TriangleRight12";
    IconNames["ArrowUpRight8"] = "ArrowUpRight8";
    IconNames["ArrowDownRight8"] = "ArrowDownRight8";
    IconNames["DocumentSet"] = "DocumentSet";
    IconNames["DelveAnalytics"] = "DelveAnalytics";
    IconNames["ArrowUpRightMirrored8"] = "ArrowUpRightMirrored8";
    IconNames["ArrowDownRightMirrored8"] = "ArrowDownRightMirrored8";
    IconNames["OneDriveAdd"] = "OneDriveAdd";
    IconNames["Header2"] = "Header2";
    IconNames["Header3"] = "Header3";
    IconNames["Header4"] = "Header4";
    IconNames["MarketDown"] = "MarketDown";
    IconNames["CalendarWorkWeek"] = "CalendarWorkWeek";
    IconNames["SidePanel"] = "SidePanel";
    IconNames["GlobeFavorite"] = "GlobeFavorite";
    IconNames["CaretTopLeftSolid8"] = "CaretTopLeftSolid8";
    IconNames["CaretTopRightSolid8"] = "CaretTopRightSolid8";
    IconNames["ViewAll2"] = "ViewAll2";
    IconNames["DocumentReply"] = "DocumentReply";
    IconNames["PlayerSettings"] = "PlayerSettings";
    IconNames["ReceiptForward"] = "ReceiptForward";
    IconNames["ReceiptReply"] = "ReceiptReply";
    IconNames["ReceiptCheck"] = "ReceiptCheck";
    IconNames["Fax"] = "Fax";
    IconNames["RecurringEvent"] = "RecurringEvent";
    IconNames["ReplyAlt"] = "ReplyAlt";
    IconNames["ReplyAllAlt"] = "ReplyAllAlt";
    IconNames["EditStyle"] = "EditStyle";
    IconNames["EditMail"] = "EditMail";
    IconNames["Lifesaver"] = "Lifesaver";
    IconNames["LifesaverLock"] = "LifesaverLock";
    IconNames["InboxCheck"] = "InboxCheck";
    IconNames["FolderSearch"] = "FolderSearch";
    IconNames["CollapseMenu"] = "CollapseMenu";
    IconNames["ExpandMenu"] = "ExpandMenu";
    IconNames["Boards"] = "Boards";
    IconNames["SunAdd"] = "SunAdd";
    IconNames["SunQuestionMark"] = "SunQuestionMark";
    IconNames["LandscapeOrientation"] = "LandscapeOrientation";
    IconNames["DocumentSearch"] = "DocumentSearch";
    IconNames["PublicCalendar"] = "PublicCalendar";
    IconNames["PublicContactCard"] = "PublicContactCard";
    IconNames["PublicEmail"] = "PublicEmail";
    IconNames["PublicFolder"] = "PublicFolder";
    IconNames["WordDocument"] = "WordDocument";
    IconNames["PowerPointDocument"] = "PowerPointDocument";
    IconNames["ExcelDocument"] = "ExcelDocument";
    IconNames["GroupedList"] = "GroupedList";
    IconNames["ClassroomLogo"] = "ClassroomLogo";
    IconNames["Sections"] = "Sections";
    IconNames["EditPhoto"] = "EditPhoto";
    IconNames["Starburst"] = "Starburst";
    IconNames["ShareiOS"] = "ShareiOS";
    IconNames["AirTickets"] = "AirTickets";
    IconNames["PencilReply"] = "PencilReply";
    IconNames["Tiles2"] = "Tiles2";
    IconNames["SkypeCircleCheck"] = "SkypeCircleCheck";
    IconNames["SkypeCircleClock"] = "SkypeCircleClock";
    IconNames["SkypeCircleMinus"] = "SkypeCircleMinus";
    IconNames["SkypeCheck"] = "SkypeCheck";
    IconNames["SkypeClock"] = "SkypeClock";
    IconNames["SkypeMinus"] = "SkypeMinus";
    IconNames["SkypeMessage"] = "SkypeMessage";
    IconNames["ClosedCaption"] = "ClosedCaption";
    IconNames["ATPLogo"] = "ATPLogo";
    IconNames["OfficeFormsLogoInverse"] = "OfficeFormsLogoInverse";
    IconNames["RecycleBin"] = "RecycleBin";
    IconNames["EmptyRecycleBin"] = "EmptyRecycleBin";
    IconNames["Hide2"] = "Hide2";
    IconNames["iOSAppStoreLogo"] = "iOSAppStoreLogo";
    IconNames["AndroidLogo"] = "AndroidLogo";
    IconNames["Breadcrumb"] = "Breadcrumb";
    IconNames["ClearFilter"] = "ClearFilter";
    IconNames["Flow"] = "Flow";
    IconNames["PageEdit"] = "PageEdit";
    IconNames["Database"] = "Database";
    IconNames["DocumentManagement"] = "DocumentManagement";
    IconNames["CRMReport"] = "CRMReport";
    IconNames["ZipFolder"] = "ZipFolder";
    IconNames["TextDocument"] = "TextDocument";
    IconNames["PageCheckedOut"] = "PageCheckedOut";
    IconNames["SaveAndClose"] = "SaveAndClose";
    IconNames["Script"] = "Script";
    IconNames["Archive"] = "Archive";
    IconNames["ActivityFeed"] = "ActivityFeed";
    IconNames["EventDate"] = "EventDate";
    IconNames["CaretRight"] = "CaretRight";
    IconNames["SetAction"] = "SetAction";
    IconNames["CaretSolidLeft"] = "CaretSolidLeft";
    IconNames["CaretSolidDown"] = "CaretSolidDown";
    IconNames["CaretSolidRight"] = "CaretSolidRight";
    IconNames["CaretSolidUp"] = "CaretSolidUp";
    IconNames["PowerAppsLogo"] = "PowerAppsLogo";
    IconNames["PowerApps2Logo"] = "PowerApps2Logo";
    IconNames["SearchIssue"] = "SearchIssue";
    IconNames["SearchIssueMirrored"] = "SearchIssueMirrored";
    IconNames["FabricAssetLibrary"] = "FabricAssetLibrary";
    IconNames["FabricDataConnectionLibrary"] = "FabricDataConnectionLibrary";
    IconNames["FabricDocLibrary"] = "FabricDocLibrary";
    IconNames["FabricFormLibrary"] = "FabricFormLibrary";
    IconNames["FabricFormLibraryMirrored"] = "FabricFormLibraryMirrored";
    IconNames["FabricReportLibrary"] = "FabricReportLibrary";
    IconNames["FabricReportLibraryMirrored"] = "FabricReportLibraryMirrored";
    IconNames["FabricPublicFolder"] = "FabricPublicFolder";
    IconNames["FabricFolderSearch"] = "FabricFolderSearch";
    IconNames["FabricMovetoFolder"] = "FabricMovetoFolder";
    IconNames["FabricUnsyncFolder"] = "FabricUnsyncFolder";
    IconNames["FabricSyncFolder"] = "FabricSyncFolder";
    IconNames["FabricOpenFolderHorizontal"] = "FabricOpenFolderHorizontal";
    IconNames["FabricFolder"] = "FabricFolder";
    IconNames["FabricFolderFill"] = "FabricFolderFill";
    IconNames["FabricNewFolder"] = "FabricNewFolder";
    IconNames["FabricPictureLibrary"] = "FabricPictureLibrary";
    IconNames["AddFavorite"] = "AddFavorite";
    IconNames["AddFavoriteFill"] = "AddFavoriteFill";
    IconNames["BufferTimeBefore"] = "BufferTimeBefore";
    IconNames["BufferTimeAfter"] = "BufferTimeAfter";
    IconNames["BufferTimeBoth"] = "BufferTimeBoth";
    IconNames["CannedChat"] = "CannedChat";
    IconNames["SkypeForBusinessLogo"] = "SkypeForBusinessLogo";
    IconNames["PageCheckedin"] = "PageCheckedin";
    IconNames["CaretBottomLeftSolid8"] = "CaretBottomLeftSolid8";
    IconNames["CaretBottomRightSolid8"] = "CaretBottomRightSolid8";
    IconNames["FolderHorizontal"] = "FolderHorizontal";
    IconNames["MicrosoftStaffhubLogo"] = "MicrosoftStaffhubLogo";
    IconNames["GiftboxOpen"] = "GiftboxOpen";
    IconNames["StatusCircleOuter"] = "StatusCircleOuter";
    IconNames["StatusCircleInner"] = "StatusCircleInner";
    IconNames["StatusCircleCheckmark"] = "StatusCircleCheckmark";
    IconNames["ExploreContentSingle"] = "ExploreContentSingle";
    IconNames["CollapseContent"] = "CollapseContent";
    IconNames["CollapseContentSingle"] = "CollapseContentSingle";
    IconNames["InfoSolid"] = "InfoSolid";
    IconNames["ProgressRingDots"] = "ProgressRingDots";
    IconNames["CaloriesAdd"] = "CaloriesAdd";
    IconNames["BranchFork"] = "BranchFork";
    IconNames["HardDriveGroup"] = "HardDriveGroup";
    IconNames["BucketColor"] = "BucketColor";
    IconNames["BucketColorFill"] = "BucketColorFill";
    IconNames["Taskboard"] = "Taskboard";
    IconNames["SingleColumn"] = "SingleColumn";
    IconNames["DoubleColumn"] = "DoubleColumn";
    IconNames["TripleColumn"] = "TripleColumn";
    IconNames["ColumnLeftTwoThirds"] = "ColumnLeftTwoThirds";
    IconNames["ColumnRightTwoThirds"] = "ColumnRightTwoThirds";
    IconNames["AccessLogoFill"] = "AccessLogoFill";
    IconNames["AnalyticsLogo"] = "AnalyticsLogo";
    IconNames["AnalyticsQuery"] = "AnalyticsQuery";
    IconNames["NewAnalyticsQuery"] = "NewAnalyticsQuery";
    IconNames["AnalyticsReport"] = "AnalyticsReport";
    IconNames["WordLogo"] = "WordLogo";
    IconNames["WordLogoFill"] = "WordLogoFill";
    IconNames["ExcelLogo"] = "ExcelLogo";
    IconNames["ExcelLogoFill"] = "ExcelLogoFill";
    IconNames["OneNoteLogo"] = "OneNoteLogo";
    IconNames["OneNoteLogoFill"] = "OneNoteLogoFill";
    IconNames["OutlookLogo"] = "OutlookLogo";
    IconNames["OutlookLogoFill"] = "OutlookLogoFill";
    IconNames["PowerPointLogo"] = "PowerPointLogo";
    IconNames["PowerPointLogoFill"] = "PowerPointLogoFill";
    IconNames["PublisherLogo"] = "PublisherLogo";
    IconNames["PublisherLogoFill"] = "PublisherLogoFill";
    IconNames["ScheduleEventAction"] = "ScheduleEventAction";
    IconNames["FlameSolid"] = "FlameSolid";
    IconNames["ServerProcesses"] = "ServerProcesses";
    IconNames["Server"] = "Server";
    IconNames["SaveAll"] = "SaveAll";
    IconNames["LinkedInLogo"] = "LinkedInLogo";
    IconNames["SidePanelMirrored"] = "SidePanelMirrored";
    IconNames["ProtectRestrict"] = "ProtectRestrict";
    IconNames["GridViewSmall"] = "GridViewSmall";
    IconNames["GridViewMedium"] = "GridViewMedium";
    IconNames["GridViewLarge"] = "GridViewLarge";
    IconNames["Step"] = "Step";
    IconNames["StepInsert"] = "StepInsert";
    IconNames["StepShared"] = "StepShared";
    IconNames["StepSharedAdd"] = "StepSharedAdd";
    IconNames["StepSharedInsert"] = "StepSharedInsert";
    IconNames["ViewDashboard"] = "ViewDashboard";
    IconNames["ViewList"] = "ViewList";
    IconNames["ViewListGroup"] = "ViewListGroup";
    IconNames["ViewListTree"] = "ViewListTree";
    IconNames["TriggerAuto"] = "TriggerAuto";
    IconNames["TriggerUser"] = "TriggerUser";
    IconNames["PivotChart"] = "PivotChart";
    IconNames["StackedBarChart"] = "StackedBarChart";
    IconNames["StackedLineChart"] = "StackedLineChart";
    IconNames["BuildQueue"] = "BuildQueue";
    IconNames["BuildQueueNew"] = "BuildQueueNew";
    IconNames["UserFollowed"] = "UserFollowed";
    IconNames["VennDiagram"] = "VennDiagram";
    IconNames["FiveTileGrid"] = "FiveTileGrid";
    IconNames["FocalPoint"] = "FocalPoint";
    IconNames["TeamsLogoInverse"] = "TeamsLogoInverse";
    IconNames["TeamsLogo"] = "TeamsLogo";
    IconNames["TeamsLogoFill"] = "TeamsLogoFill";
    IconNames["SkypeForBusinessLogoFill"] = "SkypeForBusinessLogoFill";
    IconNames["SharepointLogo"] = "SharepointLogo";
    IconNames["SharepointLogoFill"] = "SharepointLogoFill";
    IconNames["DelveLogo"] = "DelveLogo";
    IconNames["DelveLogoFill"] = "DelveLogoFill";
    IconNames["OfficeVideoLogo"] = "OfficeVideoLogo";
    IconNames["OfficeVideoLogoFill"] = "OfficeVideoLogoFill";
    IconNames["ExchangeLogo"] = "ExchangeLogo";
    IconNames["ExchangeLogoFill"] = "ExchangeLogoFill";
    IconNames["DocumentApproval"] = "DocumentApproval";
    IconNames["CloneToDesktop"] = "CloneToDesktop";
    IconNames["InstallToDrive"] = "InstallToDrive";
    IconNames["Blur"] = "Blur";
    IconNames["Build"] = "Build";
    IconNames["ProcessMetaTask"] = "ProcessMetaTask";
    IconNames["BranchFork2"] = "BranchFork2";
    IconNames["BranchLocked"] = "BranchLocked";
    IconNames["BranchCommit"] = "BranchCommit";
    IconNames["BranchCompare"] = "BranchCompare";
    IconNames["BranchMerge"] = "BranchMerge";
    IconNames["BranchPullRequest"] = "BranchPullRequest";
    IconNames["BranchSearch"] = "BranchSearch";
    IconNames["BranchShelveset"] = "BranchShelveset";
    IconNames["RawSource"] = "RawSource";
    IconNames["MergeDuplicate"] = "MergeDuplicate";
    IconNames["RowsGroup"] = "RowsGroup";
    IconNames["RowsChild"] = "RowsChild";
    IconNames["Deploy"] = "Deploy";
    IconNames["Redeploy"] = "Redeploy";
    IconNames["ServerEnviroment"] = "ServerEnviroment";
    IconNames["Plug"] = "Plug";
    IconNames["PlugSolid"] = "PlugSolid";
    IconNames["PlugConnected"] = "PlugConnected";
    IconNames["PlugDisconnected"] = "PlugDisconnected";
    IconNames["UnlockSolid"] = "UnlockSolid";
    IconNames["Variable"] = "Variable";
    IconNames["Parameter"] = "Parameter";
    IconNames["CommentUrgent"] = "CommentUrgent";
    IconNames["Storyboard"] = "Storyboard";
    IconNames["DiffInline"] = "DiffInline";
    IconNames["DiffSideBySide"] = "DiffSideBySide";
    IconNames["ImageDiff"] = "ImageDiff";
    IconNames["ImagePixel"] = "ImagePixel";
    IconNames["FileBug"] = "FileBug";
    IconNames["FileCode"] = "FileCode";
    IconNames["FileComment"] = "FileComment";
    IconNames["FileImage"] = "FileImage";
    IconNames["FileSymlink"] = "FileSymlink";
    IconNames["AutoFillTemplate"] = "AutoFillTemplate";
    IconNames["WorkItem"] = "WorkItem";
    IconNames["WorkItemBug"] = "WorkItemBug";
    IconNames["LogRemove"] = "LogRemove";
    IconNames["ColumnOptions"] = "ColumnOptions";
    IconNames["Packages"] = "Packages";
    IconNames["BuildIssue"] = "BuildIssue";
    IconNames["AssessmentGroup"] = "AssessmentGroup";
    IconNames["VariableGroup"] = "VariableGroup";
    IconNames["FullHistory"] = "FullHistory";
    IconNames["BusinessHoursSign"] = "BusinessHoursSign";
    IconNames["VisioDiagram"] = "VisioDiagram";
    IconNames["HighlightMappedShapes"] = "HighlightMappedShapes";
    IconNames["TextCallout"] = "TextCallout";
    IconNames["IconSetsFlag"] = "IconSetsFlag";
    IconNames["VisioLogo"] = "VisioLogo";
    IconNames["VisioLogoFill"] = "VisioLogoFill";
    IconNames["VisioDocument"] = "VisioDocument";
    IconNames["TimelineProgress"] = "TimelineProgress";
    IconNames["TimelineDelivery"] = "TimelineDelivery";
    IconNames["Backlog"] = "Backlog";
    IconNames["TeamFavorite"] = "TeamFavorite";
    IconNames["TaskGroup"] = "TaskGroup";
    IconNames["TaskGroupMirrored"] = "TaskGroupMirrored";
    IconNames["ScopeTemplate"] = "ScopeTemplate";
    IconNames["AssessmentGroupTemplate"] = "AssessmentGroupTemplate";
    IconNames["NewTeamProject"] = "NewTeamProject";
    IconNames["CommentAdd"] = "CommentAdd";
    IconNames["CommentNext"] = "CommentNext";
    IconNames["CommentPrevious"] = "CommentPrevious";
    IconNames["ShopServer"] = "ShopServer";
    IconNames["LocaleLanguage"] = "LocaleLanguage";
    IconNames["QueryList"] = "QueryList";
    IconNames["UserSync"] = "UserSync";
    IconNames["UserPause"] = "UserPause";
    IconNames["StreamingOff"] = "StreamingOff";
    IconNames["MoreVertical"] = "MoreVertical";
    IconNames["ArrowTallUpLeft"] = "ArrowTallUpLeft";
    IconNames["ArrowTallUpRight"] = "ArrowTallUpRight";
    IconNames["ArrowTallDownLeft"] = "ArrowTallDownLeft";
    IconNames["ArrowTallDownRight"] = "ArrowTallDownRight";
    IconNames["FieldEmpty"] = "FieldEmpty";
    IconNames["FieldFilled"] = "FieldFilled";
    IconNames["FieldChanged"] = "FieldChanged";
    IconNames["FieldNotChanged"] = "FieldNotChanged";
    IconNames["RingerOff"] = "RingerOff";
    IconNames["PlayResume"] = "PlayResume";
    IconNames["BulletedList2"] = "BulletedList2";
    IconNames["BulletedList2Mirrored"] = "BulletedList2Mirrored";
    IconNames["ImageCrosshair"] = "ImageCrosshair";
    IconNames["GitGraph"] = "GitGraph";
    IconNames["Repo"] = "Repo";
    IconNames["RepoSolid"] = "RepoSolid";
    IconNames["FolderQuery"] = "FolderQuery";
    IconNames["FolderList"] = "FolderList";
    IconNames["FolderListMirrored"] = "FolderListMirrored";
    IconNames["LocationOutline"] = "LocationOutline";
    IconNames["POISolid"] = "POISolid";
    IconNames["CalculatorNotEqualTo"] = "CalculatorNotEqualTo";
    IconNames["BoxSubtractSolid"] = "BoxSubtractSolid";
    IconNames["BoxAdditionSolid"] = "BoxAdditionSolid";
    IconNames["BoxMultiplySolid"] = "BoxMultiplySolid";
    IconNames["BoxPlaySolid"] = "BoxPlaySolid";
    IconNames["BoxCheckmarkSolid"] = "BoxCheckmarkSolid";
    IconNames["CirclePauseSolid"] = "CirclePauseSolid";
    IconNames["CirclePause"] = "CirclePause";
    IconNames["MSNVideosSolid"] = "MSNVideosSolid";
    IconNames["CircleStopSolid"] = "CircleStopSolid";
    IconNames["CircleStop"] = "CircleStop";
    IconNames["NavigateBack"] = "NavigateBack";
    IconNames["NavigateBackMirrored"] = "NavigateBackMirrored";
    IconNames["NavigateForward"] = "NavigateForward";
    IconNames["NavigateForwardMirrored"] = "NavigateForwardMirrored";
    IconNames["UnknownSolid"] = "UnknownSolid";
    IconNames["UnknownMirroredSolid"] = "UnknownMirroredSolid";
    IconNames["CircleAddition"] = "CircleAddition";
    IconNames["CircleAdditionSolid"] = "CircleAdditionSolid";
    IconNames["FilePDB"] = "FilePDB";
    IconNames["FileTemplate"] = "FileTemplate";
    IconNames["FileSQL"] = "FileSQL";
    IconNames["FileJAVA"] = "FileJAVA";
    IconNames["FileASPX"] = "FileASPX";
    IconNames["FileCSS"] = "FileCSS";
    IconNames["FileSass"] = "FileSass";
    IconNames["FileLess"] = "FileLess";
    IconNames["FileHTML"] = "FileHTML";
    IconNames["JavaScriptLanguage"] = "JavaScriptLanguage";
    IconNames["CSharpLanguage"] = "CSharpLanguage";
    IconNames["CSharp"] = "CSharp";
    IconNames["VisualBasicLanguage"] = "VisualBasicLanguage";
    IconNames["VB"] = "VB";
    IconNames["CPlusPlusLanguage"] = "CPlusPlusLanguage";
    IconNames["CPlusPlus"] = "CPlusPlus";
    IconNames["FSharpLanguage"] = "FSharpLanguage";
    IconNames["FSharp"] = "FSharp";
    IconNames["TypeScriptLanguage"] = "TypeScriptLanguage";
    IconNames["PythonLanguage"] = "PythonLanguage";
    IconNames["PY"] = "PY";
    IconNames["CoffeeScript"] = "CoffeeScript";
    IconNames["MarkDownLanguage"] = "MarkDownLanguage";
    IconNames["FullWidth"] = "FullWidth";
    IconNames["FullWidthEdit"] = "FullWidthEdit";
    IconNames["SingleColumnEdit"] = "SingleColumnEdit";
    IconNames["DoubleColumnEdit"] = "DoubleColumnEdit";
    IconNames["TripleColumnEdit"] = "TripleColumnEdit";
    IconNames["ColumnLeftTwoThirdsEdit"] = "ColumnLeftTwoThirdsEdit";
    IconNames["ColumnRightTwoThirdsEdit"] = "ColumnRightTwoThirdsEdit";
    IconNames["StreamLogo"] = "StreamLogo";
    IconNames["AlertSolid"] = "AlertSolid";
    IconNames["MegaphoneSolid"] = "MegaphoneSolid";
    IconNames["TaskSolid"] = "TaskSolid";
    IconNames["ConfigurationSolid"] = "ConfigurationSolid";
    IconNames["BugSolid"] = "BugSolid";
    IconNames["CrownSolid"] = "CrownSolid";
    IconNames["Trophy2Solid"] = "Trophy2Solid";
    IconNames["QuickNoteSolid"] = "QuickNoteSolid";
    IconNames["ConstructionConeSolid"] = "ConstructionConeSolid";
    IconNames["PageListSolid"] = "PageListSolid";
    IconNames["PageListMirroredSolid"] = "PageListMirroredSolid";
    IconNames["StarburstSolid"] = "StarburstSolid";
    IconNames["ReadingModeSolid"] = "ReadingModeSolid";
    IconNames["SadSolid"] = "SadSolid";
    IconNames["HealthSolid"] = "HealthSolid";
    IconNames["ShieldSolid"] = "ShieldSolid";
    IconNames["GiftBoxSolid"] = "GiftBoxSolid";
    IconNames["ShoppingCartSolid"] = "ShoppingCartSolid";
    IconNames["MailSolid"] = "MailSolid";
    IconNames["ChatSolid"] = "ChatSolid";
    IconNames["RibbonSolid"] = "RibbonSolid";
    IconNames["FinancialSolid"] = "FinancialSolid";
    IconNames["FinancialMirroredSolid"] = "FinancialMirroredSolid";
    IconNames["HeadsetSolid"] = "HeadsetSolid";
    IconNames["PermissionsSolid"] = "PermissionsSolid";
    IconNames["ParkingSolid"] = "ParkingSolid";
    IconNames["ParkingMirroredSolid"] = "ParkingMirroredSolid";
    IconNames["DiamondSolid"] = "DiamondSolid";
    IconNames["AsteriskSolid"] = "AsteriskSolid";
    IconNames["OfflineStorageSolid"] = "OfflineStorageSolid";
    IconNames["BankSolid"] = "BankSolid";
    IconNames["DecisionSolid"] = "DecisionSolid";
    IconNames["Parachute"] = "Parachute";
    IconNames["ParachuteSolid"] = "ParachuteSolid";
    IconNames["FiltersSolid"] = "FiltersSolid";
    IconNames["ColorSolid"] = "ColorSolid";
    IconNames["ReviewSolid"] = "ReviewSolid";
    IconNames["ReviewRequestSolid"] = "ReviewRequestSolid";
    IconNames["ReviewRequestMirroredSolid"] = "ReviewRequestMirroredSolid";
    IconNames["ReviewResponseSolid"] = "ReviewResponseSolid";
    IconNames["FeedbackRequestSolid"] = "FeedbackRequestSolid";
    IconNames["FeedbackRequestMirroredSolid"] = "FeedbackRequestMirroredSolid";
    IconNames["FeedbackResponseSolid"] = "FeedbackResponseSolid";
    IconNames["WorkItemBar"] = "WorkItemBar";
    IconNames["WorkItemBarSolid"] = "WorkItemBarSolid";
    IconNames["Separator"] = "Separator";
    IconNames["NavigateExternalInline"] = "NavigateExternalInline";
    IconNames["PlanView"] = "PlanView";
    IconNames["TimelineMatrixView"] = "TimelineMatrixView";
    IconNames["EngineeringGroup"] = "EngineeringGroup";
    IconNames["ProjectCollection"] = "ProjectCollection";
    IconNames["CaretBottomRightCenter8"] = "CaretBottomRightCenter8";
    IconNames["CaretBottomLeftCenter8"] = "CaretBottomLeftCenter8";
    IconNames["CaretTopRightCenter8"] = "CaretTopRightCenter8";
    IconNames["CaretTopLeftCenter8"] = "CaretTopLeftCenter8";
    IconNames["DonutChart"] = "DonutChart";
    IconNames["ChevronUnfold10"] = "ChevronUnfold10";
    IconNames["ChevronFold10"] = "ChevronFold10";
    IconNames["DoubleChevronDown8"] = "DoubleChevronDown8";
    IconNames["DoubleChevronUp8"] = "DoubleChevronUp8";
    IconNames["DoubleChevronLeft8"] = "DoubleChevronLeft8";
    IconNames["DoubleChevronRight8"] = "DoubleChevronRight8";
    IconNames["ChevronDownEnd6"] = "ChevronDownEnd6";
    IconNames["ChevronUpEnd6"] = "ChevronUpEnd6";
    IconNames["ChevronLeftEnd6"] = "ChevronLeftEnd6";
    IconNames["ChevronRightEnd6"] = "ChevronRightEnd6";
    IconNames["EgnyteLogo"] = "EgnyteLogo";
    IconNames["GoogleDriveLogoLeftGreen"] = "GoogleDriveLogoLeftGreen";
    IconNames["GoogleDriveLogoBottomBlue"] = "GoogleDriveLogoBottomBlue";
    IconNames["GoogleDriveLogoRightYellow"] = "GoogleDriveLogoRightYellow";
    IconNames["AzureAPIManagement"] = "AzureAPIManagement";
    IconNames["AzureServiceEndpoint"] = "AzureServiceEndpoint";
    IconNames["VSTSLogo"] = "VSTSLogo";
    IconNames["VSTSAltLogo1"] = "VSTSAltLogo1";
    IconNames["VSTSAltLogo2"] = "VSTSAltLogo2";
    IconNames["FileTypeSolution"] = "FileTypeSolution";
    IconNames["WordLogoInverse16"] = "WordLogoInverse16";
    IconNames["WordLogo16"] = "WordLogo16";
    IconNames["WordLogoFill16"] = "WordLogoFill16";
    IconNames["PowerPointLogoInverse16"] = "PowerPointLogoInverse16";
    IconNames["PowerPointLogo16"] = "PowerPointLogo16";
    IconNames["PowerPointLogoFill16"] = "PowerPointLogoFill16";
    IconNames["ExcelLogoInverse16"] = "ExcelLogoInverse16";
    IconNames["ExcelLogo16"] = "ExcelLogo16";
    IconNames["ExcelLogoFill16"] = "ExcelLogoFill16";
    IconNames["OneNoteLogoInverse16"] = "OneNoteLogoInverse16";
    IconNames["OneNoteLogo16"] = "OneNoteLogo16";
    IconNames["OneNoteLogoFill16"] = "OneNoteLogoFill16";
    IconNames["OutlookLogoInverse16"] = "OutlookLogoInverse16";
    IconNames["OutlookLogo16"] = "OutlookLogo16";
    IconNames["OutlookLogoFill16"] = "OutlookLogoFill16";
    IconNames["PublisherLogoInverse16"] = "PublisherLogoInverse16";
    IconNames["PublisherLogo16"] = "PublisherLogo16";
    IconNames["PublisherLogoFill16"] = "PublisherLogoFill16";
    IconNames["VisioLogoInverse16"] = "VisioLogoInverse16";
    IconNames["VisioLogo16"] = "VisioLogo16";
    IconNames["VisioLogoFill16"] = "VisioLogoFill16";
    IconNames["TestBeaker"] = "TestBeaker";
    IconNames["TestBeakerSolid"] = "TestBeakerSolid";
    IconNames["TestExploreSolid"] = "TestExploreSolid";
    IconNames["TestAutoSolid"] = "TestAutoSolid";
    IconNames["TestUserSolid"] = "TestUserSolid";
    IconNames["TestImpactSolid"] = "TestImpactSolid";
    IconNames["TestPlan"] = "TestPlan";
    IconNames["TestStep"] = "TestStep";
    IconNames["TestParameter"] = "TestParameter";
    IconNames["TestSuite"] = "TestSuite";
    IconNames["TestCase"] = "TestCase";
    IconNames["Sprint"] = "Sprint";
    IconNames["SignOut"] = "SignOut";
    IconNames["TriggerApproval"] = "TriggerApproval";
    IconNames["Rocket"] = "Rocket";
    IconNames["AzureKeyVault"] = "AzureKeyVault";
    IconNames["LikeSolid"] = "LikeSolid";
    IconNames["DislikeSolid"] = "DislikeSolid";
    IconNames["DeclineCall"] = "DeclineCall";
    IconNames["Spacer"] = "Spacer";
    IconNames["SkypeLogo16"] = "SkypeLogo16";
    IconNames["SkypeForBusinessLogo16"] = "SkypeForBusinessLogo16";
    IconNames["SkypeForBusinessLogoFill16"] = "SkypeForBusinessLogoFill16";
    IconNames["FilterSolid"] = "FilterSolid";
    IconNames["MailUndelivered"] = "MailUndelivered";
    IconNames["MailTentative"] = "MailTentative";
    IconNames["MailTentativeMirrored"] = "MailTentativeMirrored";
    IconNames["MailReminder"] = "MailReminder";
    IconNames["ReceiptUndelivered"] = "ReceiptUndelivered";
    IconNames["ReceiptTentative"] = "ReceiptTentative";
    IconNames["ReceiptTentativeMirrored"] = "ReceiptTentativeMirrored";
    IconNames["Inbox"] = "Inbox";
    IconNames["IRMReply"] = "IRMReply";
    IconNames["IRMReplyMirrored"] = "IRMReplyMirrored";
    IconNames["IRMForward"] = "IRMForward";
    IconNames["IRMForwardMirrored"] = "IRMForwardMirrored";
    IconNames["VoicemailIRM"] = "VoicemailIRM";
    IconNames["EventAccepted"] = "EventAccepted";
    IconNames["EventTentative"] = "EventTentative";
    IconNames["EventTentativeMirrored"] = "EventTentativeMirrored";
    IconNames["EventDeclined"] = "EventDeclined";
    IconNames["IDBadge"] = "IDBadge";
    IconNames["OfficeFormsLogoInverse16"] = "OfficeFormsLogoInverse16";
    IconNames["OfficeFormsLogo"] = "OfficeFormsLogo";
    IconNames["OfficeFormsLogoFill"] = "OfficeFormsLogoFill";
    IconNames["OfficeFormsLogo16"] = "OfficeFormsLogo16";
    IconNames["OfficeFormsLogoFill16"] = "OfficeFormsLogoFill16";
    IconNames["OfficeFormsLogoInverse24"] = "OfficeFormsLogoInverse24";
    IconNames["OfficeFormsLogo24"] = "OfficeFormsLogo24";
    IconNames["OfficeFormsLogoFill24"] = "OfficeFormsLogoFill24";
    IconNames["PageLock"] = "PageLock";
    IconNames["NotExecuted"] = "NotExecuted";
    IconNames["NotImpactedSolid"] = "NotImpactedSolid";
    IconNames["FieldReadOnly"] = "FieldReadOnly";
    IconNames["FieldRequired"] = "FieldRequired";
    IconNames["BacklogBoard"] = "BacklogBoard";
    IconNames["ExternalBuild"] = "ExternalBuild";
    IconNames["ExternalTFVC"] = "ExternalTFVC";
    IconNames["ExternalXAML"] = "ExternalXAML";
    IconNames["IssueSolid"] = "IssueSolid";
    IconNames["DefectSolid"] = "DefectSolid";
    IconNames["LadybugSolid"] = "LadybugSolid";
    IconNames["MTMLogo"] = "MTMLogo";
    IconNames["NugetLogo"] = "NugetLogo";
    IconNames["TFVCLogo"] = "TFVCLogo";
    IconNames["ProjectLogo32"] = "ProjectLogo32";
    IconNames["ProjectLogoFill32"] = "ProjectLogoFill32";
    IconNames["ProjectLogo16"] = "ProjectLogo16";
    IconNames["ProjectLogoFill16"] = "ProjectLogoFill16";
    IconNames["SwayLogo32"] = "SwayLogo32";
    IconNames["SwayLogoFill32"] = "SwayLogoFill32";
    IconNames["SwayLogo16"] = "SwayLogo16";
    IconNames["SwayLogoFill16"] = "SwayLogoFill16";
    IconNames["ClassNotebookLogo32"] = "ClassNotebookLogo32";
    IconNames["ClassNotebookLogoFill32"] = "ClassNotebookLogoFill32";
    IconNames["ClassNotebookLogo16"] = "ClassNotebookLogo16";
    IconNames["ClassNotebookLogoFill16"] = "ClassNotebookLogoFill16";
    IconNames["ClassNotebookLogoInverse32"] = "ClassNotebookLogoInverse32";
    IconNames["ClassNotebookLogoInverse16"] = "ClassNotebookLogoInverse16";
    IconNames["StaffNotebookLogo32"] = "StaffNotebookLogo32";
    IconNames["StaffNotebookLogoFill32"] = "StaffNotebookLogoFill32";
    IconNames["StaffNotebookLogo16"] = "StaffNotebookLogo16";
    IconNames["StaffNotebookLogoFill16"] = "StaffNotebookLogoFill16";
    IconNames["StaffNotebookLogoInverted32"] = "StaffNotebookLogoInverted32";
    IconNames["StaffNotebookLogoInverted16"] = "StaffNotebookLogoInverted16";
    IconNames["KaizalaLogo"] = "KaizalaLogo";
    IconNames["TaskLogo"] = "TaskLogo";
    IconNames["ProtectionCenterLogo32"] = "ProtectionCenterLogo32";
    IconNames["NonprofitLogo32"] = "NonprofitLogo32";
    IconNames["GallatinLogo"] = "GallatinLogo";
    IconNames["Globe2"] = "Globe2";
    IconNames["Guitar"] = "Guitar";
    IconNames["Breakfast"] = "Breakfast";
    IconNames["Brunch"] = "Brunch";
    IconNames["BeerMug"] = "BeerMug";
    IconNames["Vacation"] = "Vacation";
    IconNames["Teeth"] = "Teeth";
    IconNames["Taxi"] = "Taxi";
    IconNames["Chopsticks"] = "Chopsticks";
    IconNames["SyncOccurence"] = "SyncOccurence";
    IconNames["UnsyncOccurence"] = "UnsyncOccurence";
    IconNames["PrimaryCalendar"] = "PrimaryCalendar";
    IconNames["SearchCalendar"] = "SearchCalendar";
    IconNames["VideoOff"] = "VideoOff";
    IconNames["MicrosoftFlowLogo"] = "MicrosoftFlowLogo";
    IconNames["BusinessCenterLogo"] = "BusinessCenterLogo";
    IconNames["ToDoLogoBottom"] = "ToDoLogoBottom";
    IconNames["ToDoLogoTop"] = "ToDoLogoTop";
    IconNames["EditSolid12"] = "EditSolid12";
    IconNames["EditSolidMirrored12"] = "EditSolidMirrored12";
    IconNames["UneditableSolid12"] = "UneditableSolid12";
    IconNames["UneditableSolidMirrored12"] = "UneditableSolidMirrored12";
    IconNames["UneditableMirrored"] = "UneditableMirrored";
    IconNames["AdminALogo32"] = "AdminALogo32";
    IconNames["AdminALogoFill32"] = "AdminALogoFill32";
    IconNames["ToDoLogoInverse"] = "ToDoLogoInverse";
    IconNames["Snooze"] = "Snooze";
})(IconNames = exports.IconNames || (exports.IconNames = {}));
//# sourceMappingURL=IconNames.js.map


//////////////////
// WEBPACK FOOTER
// ../~/@uifabric/icons/lib/IconNames.js
// module id = ../node_modules/@uifabric/icons/lib/IconNames.js
// module chunks = 1